/**
 * DuplicatesPrompt
 *
 * The one Merge duplicates dialog for the whole app, mounted once beside the
 * router rather than on each page that can add contacts. Every import path
 * (the address book, Settings → Import Contacts, the share flow's recipient
 * picker) queues its duplicates in the contact state, and this dialog answers
 * them wherever the user happens to be. A copy per page would stack one dialog
 * per mounted page, since Ionic keeps earlier pages in the stack mounted, and
 * leave them open on pages the user has navigated away from.
 */

import React from 'react';
import MergeDuplicatesModal from '@/components/MergeDuplicatesModal';
import { useAppToast } from '@/hooks/useAppToast';
import { useContactState } from './ContactStateContext';

const DuplicatesPrompt: React.FC = () => {
  const { dispatch, duplicatesToResolve } = useContactState();
  const [presentToast] = useAppToast();

  return (
    <MergeDuplicatesModal
      isOpen={duplicatesToResolve.length > 0}
      duplicatesToResolve={duplicatesToResolve}
      onResolve={(index, resolution) => {
        dispatch({ type: 'RESOLVE_DUPLICATE', payload: { resolution, index } });
        if (resolution === 'merge') {
          presentToast({
            message: 'Contacts merged',
            duration: 3000,
            color: 'success',
          });
        }
      }}
      onMergeAll={() => {
        duplicatesToResolve.forEach(() =>
          dispatch({
            type: 'RESOLVE_DUPLICATE',
            payload: { resolution: 'merge' },
          })
        );
        presentToast({
          message: 'All duplicates merged',
          duration: 3000,
          color: 'success',
        });
      }}
    />
  );
};

export default DuplicatesPrompt;
